import * as yup from 'yup'

export const UkResidencyDurationValidation = yup.string()
